export default function pageLoaded() {
  document.documentElement.className += ' page-loaded';
}
